var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var StyledPopover = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  max-width: ", ";\n  margin: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  position: relative;\n  max-width: ", ";\n  margin: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.popover.maxWidth;
}, function (_a) {
    var component = _a.theme.component;
    return component.popover.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.popover.backgroundColor;
}, function (_a) {
    var component = _a.theme.component;
    return component.popover.borderColor;
}, function (_a) {
    var component = _a.theme.component;
    return component.popover.borderRadius;
}, function (_a) {
    var component = _a.theme.component;
    return component.popover.boxShadow;
});
export default StyledPopover;
var templateObject_1;
//# sourceMappingURL=index.js.map